import turboInit from "../../shared/utils/turbo-init"

// Reports the result count when the search frame updates.
//
// Filtering swaps the contents of the `missions_search_results` frame, which
// gives a screen reader user no clue that anything happened. The heading inside
// the frame already says "34 uppdrag" – this copies it into the persistent live
// region on the page, which is the only element that survives the swap and can
// therefore announce.
turboInit(() => {
  const statusEl = document.querySelector(`.js--mission-search-status`)
  const frameEl = document.getElementById(`missions_search_results`)
  if (!statusEl || !frameEl) return undefined

  const announce = () => {
    const headingEl = frameEl.querySelector(
      `.mission-search-page-header__heading`
    )

    // No heading means no results; the frame renders an alert instead.
    const emptyEl = frameEl.querySelector(`.vb-alert__content`)
    const message = (headingEl || emptyEl)?.textContent
      .replace(/\s+/g, ` `)
      .trim()

    if (!message || message === statusEl.textContent) return

    statusEl.textContent = message
  }

  frameEl.addEventListener(`turbo:frame-load`, announce)

  return () => frameEl.removeEventListener(`turbo:frame-load`, announce)
})
